/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2025-08-14 12:02:15
 * @ Description: Component wrapper used to pass user information from the GET_ME query to other components along with other component that can be accessed universally
 */

import React from 'react'
import { GET_ME } from './queries'
import CircularProgress from '@mui/material/CircularProgress'
import Backdrop from '@mui/material/Backdrop'
import ErrorBoundary from './ErrorBoundary'
import Upsell from '@/housefolios-components/Upsell'

// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'
import { useQuery } from "@apollo/client/react";
import AffiliateSubscribeDialog from './AffiliateSubscribeDialog'

const SIGNED_OUT_SESSION = { me: null }

const withSession = (Component) => (props) => {
  const [openSubscribe, setOpenSubscribe] = React.useState(false)
  const toggleSubscribe = (limit) => {
    setOpenSubscribe(!openSubscribe)
  }
  const [openLimit, setOpenLimit] = React.useState('')

  const toggleLimit = (limit) => {
    setOpenLimit(limit)
  }
  const closeLimit = () => {
    setOpenLimit('')
  }
  //console.log("session", props)

  const { loading, data, error, refetch } = useQuery(GET_ME, {
    errorPolicy: 'all',
  })
  // AC4 can report loading during background refetch; don't unmount the app.
  if (loading && !data && !error)
    return (
      <Backdrop
        open
        style={{ color: '#fff', zIndex: 2000 }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    )

  // GET_ME network/GraphQL failures must not block /signin. SessionOut used
  // to replace Routes entirely, so Refresh/Sign in could never mount login.
  const session = data || SIGNED_OUT_SESSION

  return (
    <ErrorBoundary>
      <Component
        {...props}
        session={session}
        refetch={refetch}
        toggleSubscribe={toggleSubscribe}
        toggleLimit={
          session.me?.activeOrg
            ? isEmpty(session.me.activeOrg.subscriptions)
              ? toggleSubscribe
              : toggleLimit
            : toggleLimit
        }
      />
      {session.me &&
        Boolean(openSubscribe) &&
        session.me?.activeOrg?.member !== 'pep' && (
          <AffiliateSubscribeDialog
            session={session}
            open={openSubscribe}
            onClose={toggleSubscribe}
          />
        )}
      {Boolean(openLimit) && (
        <Upsell
          openLimit={openLimit}
          session={session}
          closeLimit={closeLimit}
        />
      )}
    </ErrorBoundary>
  )
}

export default withSession
